import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const Chair: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <g clipPath="url(#clip0_507_581)">
                <IconPath
                    d="M6 17.25L2.756 2.976C2.65111 2.50444 2.73783 2.01053 2.9971 1.60292C3.25637 1.19531 3.66695 0.90739 4.1385 0.802496C4.61005 0.697603 5.10396 0.784331 5.51158 1.0436C5.91919 1.30287 6.20711 1.71344 6.312 2.185L8.352 11.569C8.42483 11.9036 8.60998 12.2033 8.87667 12.4181C9.14336 12.6329 9.47554 12.7501 9.818 12.75H18.75C19.5456 12.75 20.3087 13.0661 20.8713 13.6287C21.4339 14.1913 21.75 14.9543 21.75 15.75V17.25H6ZM6 17.25L2.25 23.25M17.25 23.25V9.75C17.25 9.35217 17.092 8.97064 16.8107 8.68934C16.5294 8.40803 16.1478 8.25 15.75 8.25H7.631"
                    {...pathProps}
                />
            </g>
            <defs>
                <clipPath id="clip0_507_581">
                    <rect width="24" height="24" fill="transparent" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
